// Универсальная функция для извлечения массива из ответа API
export function extractArrayFromResponse<T>(data: any, defaultValue: T[] = []): T[] {
  if (!data) return defaultValue;
  
  // Если уже массив
  if (Array.isArray(data)) return data;
  
  // Если объект с полем data
  if (data.data && Array.isArray(data.data)) return data.data;
  
  // Если объект с полем items
  if (data.items && Array.isArray(data.items)) return data.items;
  
  // Если объект с полем results
  if (data.results && Array.isArray(data.results)) return data.results;
  
  // Если объект с полем guides/tours/etc
  const keys = Object.keys(data);
  for (const key of keys) {
    if (Array.isArray(data[key])) return data[key];
  }
  
  // Пробуем преобразовать объект в массив
  const values = Object.values(data);
  if (values.length > 0 && values.some(v => v && typeof v === 'object')) {
    return values as T[];
  }
  
  return defaultValue;
}

// Универсальная функция для безопасного извлечения данных
export function safeGet<T>(data: any, path: string, defaultValue: any = null): T {
  if (!data) return defaultValue;
  const keys = path.split('.');
  let result = data;
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return defaultValue;
    }
  }
  return result;
}
